import React from "react";
import { Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

export function ConsoleError({ retry }: { retry?: () => void }) {
  const { t } = useTranslation();
  return (
    <Alert
      severity="error"
      action={
        retry && (
          <Button variant="default-outlined" onClick={retry}>
            {t("Retry")}
          </Button>
        )
      }
    >
      {t("This information is unavailable or access is denied")}
    </Alert>
  );
}

export function ConsoleContinue({
  paused,
  loadMore,
}: {
  paused: boolean;
  loadMore: () => void;
}) {
  const { t } = useTranslation();
  if (!paused) return null;
  return (
    <Alert
      severity="info"
      action={
        <Button variant="default-outlined" onClick={loadMore}>
          {t("Keep searching")}
        </Button>
      }
    >
      {t("More records may match your filters")}
    </Alert>
  );
}
